import { createFileRoute, redirect } from '@tanstack/react-router'
export const Route = createFileRoute('/devices')({ beforeLoad: () => { throw redirect({ to: '/account', hash: 'devices' }) } })
